<template>
    <div class="Tab">
        <RPNavTab
            :label="label"
            :to="to"
            :active-tab="activeTab"
            :is-active="isSubActive"
            :disabled="disabled"
            @navigate="to => $emit('navigate', to)"
        />

        <template v-if="isSubActive">
            <RPSubTab
                v-if="useDynamic"
                tag="div"
                :is-active="true"
                :label="dynamicTab"
                class="Tab__subtab"
            />
            <template v-else>
                <template v-for="sub in subTabs">
                    <RPSubTab
                        v-if="sub.label"
                        :key="JSON.stringify(sub)"
                        tag="button"
                        :to="sub.to"
                        :active-tab="activeTab"
                        :label="sub.label"
                        class="Tab__subtab"
                        @navigate="to => $emit('navigate', to)"
                    />
                </template>
            </template>
        </template>
    </div>
</template>

<script>
import RPNavTab from '@/components/Basic/Buttons/RPNavTab.vue';
import RPSubTab from '@/components/Basic/Buttons/RPSubTab.vue';

export default {
    name: "Tab",
    components: {
        RPNavTab,
        RPSubTab
    },
    props: {
        label: {
            type: String,
            required: true
        },
        to: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        subTabs: {
            type: Array,
            default: () => ([])
        },
        activeTab: {
            type: String,
            required: true
        },
        dynamicTab: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            hover: false,
        };
    },
    computed: {
        isSubActive() {
            return this.subTabs.findIndex(sub => sub.to.name === this.activeTab) > -1;
        },
        useDynamic(){
            return this.dynamicTab !== '';
        }
    },
};
</script>

<style lang="scss">
.Tab {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.25rem;
    &__subtab{
        margin: 0.5rem 0 0 1rem;
    }
}
</style>